"use client";

import type { Article } from "@/app/types/blogTypes";
import { motion } from "framer-motion";
import { Calendar, EyeIcon } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

type ArticleProps = {
  article: Article;
};

export default function BlogCard({ article }: ArticleProps) {
  return (
    <motion.div whileHover={{ scale: 0.98 }} key={article.id}>
      <Link href={`/blog/${article.slug}`}>
        <motion.div
          className="relative flex pb-4 overflow-hidden"
          whileTap={{ scale: 0.95 }}
        >
          <div className="relative aspect-video w-full">
            {article?.cover?.formats?.large && (
              <Image
                key={article.id}
                src={`${article.cover.formats.large.url}`}
                alt={`${article.cover.alternativeText}`}
                fill
                className="object-cover rounded-2xl"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
            )}
          </div>
          <div className="absolute bottom-8 left-4 flex flex-col gap-2">
            <div className="items-center flex gap-2">
              {article?.tags?.map((tag) => {
                return (
                  <div
                    key={tag.id}
                    className="rounded-full items-center gap-1 flex justify-center text-xs py-1 px-2 font-bold"
                    style={{
                      backgroundColor: tag?.color?.background,
                      color: tag?.color?.text,
                    }}
                  >
                    {tag?.icon && (
                      <Image
                        src={tag.icon[0].url}
                        alt=""
                        width={12}
                        height={12}
                      />
                    )}
                    {tag?.name}
                  </div>
                );
              })}
            </div>
          </div>
        </motion.div>
        <div className="flex flex-col gap-2 pb-3">
          <h2 className="w-[90%] text-xl">{article?.title}</h2>
          <div className="flex gap-2 items-center mt-2 md:mt-1">
            <div className="flex items-center gap-2">
              <Calendar size={20} className="text-gray-600" />
              <p className="text-gray-600 items-center text-xs ">
                {new Date(article?.createdAt).toLocaleDateString("pt-BR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </p>
            </div>
            <span className="text-gray-600">|</span>
            <div className="flex items-center gap-2">
              <EyeIcon size={20} className="text-gray-600" />
              <p className="text-gray-600 items-center text-xs ">
                {article.readingTimeNew} min de leitura
              </p>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
